import { createSlice } from "@reduxjs/toolkit";
import staffList from "../layouts/dashboard/header/staffList";

const initialState = {
	user: null,
	idToken: localStorage.getItem("idToken") || null,
	isLoading: true,
	role: "user",
};

export const authSlice = createSlice({
	name: "auth",
	initialState,
	reducers: {
		loginUser: (state, action) => {
			state.user = {
				uid: action.payload.uid,
				email: action.payload.email,
				displayName: action.payload.displayName,
			};
			state.idToken = action.payload.idToken;

			localStorage.setItem("idToken", action.payload.idToken);

			const matchedStaff = staffList.find(
				(staff) => staff.email === state.user.email
			);
			state.role = matchedStaff ? matchedStaff.role : "user";
		},
		logoutUser: (state) => {
			state.user = null;
			state.idToken = null;
			state.role = "user";
			localStorage.removeItem("idToken");
		},
		setLoading: (state, action) => {
			state.isLoading = action.payload;
		},
	},
});

export const { loginUser, logoutUser, setLoading } = authSlice.actions;
export default authSlice.reducer;
